// Home.js
import React from 'react';
import Layout from '../Components/Layout';
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home-banner-image.png";
import { useNavigate } from 'react-router-dom'; 

import { FiArrowRight } from "react-icons/fi";
import Work from "./Work";
import Testimonial from "./Testimonial";
import About from "./About";

const Home = ({ openLoginModal, openRegisterModal }) => {
    const navigate = useNavigate(); 

    const handleNavigate = () => {
        navigate('/recipes');
    };

    return (
        <Layout openLoginModal={openLoginModal} openRegisterModal={openRegisterModal}>
        <div className='home-container'>
                <div className='home-banner-container'>
                    <div className='home-bannerImage-container'>
                        <img src={BannerBackground} alt=""/>
                    </div>
                    <div className='home-text-section'>
                        <h1 className='primary-heading'>
                            Ervaar een Sterren Restaurant, maar dan thuis!
                        </h1>
                        <p className='primary-text'>
                            Duik in onze menu's en geniet van de beste gerechten die je ooit hebt geproefd, bereid door onze topchefs.
                        </p>
                        <button className='secondary-button' onClick={handleNavigate}>
                            Bekijk nu onze culinaire gerechten <FiArrowRight />{""}
                        </button>
                    </div>
                    <div className='home-image-section'>
                        <img src={BannerImage} alt=''/>
                    </div>
                </div>
            </div>
            <About/>
            <Work/>
            <Testimonial/>
        </Layout>
    );
};

export default Home;